import { render, staticRenderFns } from "./BindSnookerAdminDialog.vue?vue&type=template&id=55af88d6&"
import script from "./BindSnookerAdminDialog.vue?vue&type=script&lang=js&"
export * from "./BindSnookerAdminDialog.vue?vue&type=script&lang=js&"
import style0 from "./BindSnookerAdminDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports